import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import * as moment from 'moment';

import { ListValueFilterModalComponent } from '../list-value-filter-modal/list-value-filter-modal.component';
import { QuestionUnconformityResponseService } from '../../service/question-unconformity-response.service';
import { GenericIntegrationService } from '../../service/generic-integration.service';
import { GenericIntegrationModel } from '../../model/generic-integration.model';
import { ListValueService } from '../../service/list-value.service';
import { MessageComponent } from '../message/message.component';
import { CalendarLocale } from '../../static/calendar-locale';
import { ListValueModel } from '../../model/list-value.model';
import { ChecklistModel } from '../../model/checklist.model';
import { ReportService } from '../../service/report.service';
import { ReviewService } from '../../service/review.service';
import { UserService } from '../../service/user.service';
import { ListService } from '../../service/list.service';
import { SyncService } from '../../service/sync.service';
import { UserModel } from '../../model/user.model';
import { ListModel } from '../../model/list.model';

@Component({
	styles: [`
		.checklist_header_item_a {
			border: 1px solid #bdbdbd !important;
			margin-top: -6px !important;
			border-radius: 5px;
		}
		.checklist_header_item_b {
			padding: 10px;
		}
		.checklist_header_item_c {
			color: #58554f;
		}
	`],
	selector: 'app-checklist-response-filter-query',
	templateUrl: './checklist-response-filter-query.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChecklistResponseQueryComponent implements OnInit, AfterViewInit {
  @ViewChild(ListValueFilterModalComponent) listValueFilterModal: ListValueFilterModalComponent;
	@ViewChild(MessageComponent) message: MessageComponent;
	@Output() hasChange = new EventEmitter<any>();

	// Visual Only
	readonly calendarStyle = { 'width': '100%', 'text-align': 'center' };
	readonly alignCenter = { 'text-align': 'center' };
	readonly maxSize = { width: '100%'	};
	additionalFilter = false;

	ngOnInit() {
		// To Auto Load Data on Start
		// this.emitFilter();
	}

	ngAfterViewInit(): void {
		this.loadFilterOptions();
		this.setLastWeekDate();

		this.getReviewIntegrationFilters();
		this.getGenericIntegrationFilters();
	}

	constructor(
		protected questUncRespService: QuestionUnconformityResponseService,
		protected genericIntService: GenericIntegrationService,
		protected listValueService: ListValueService,
		protected reportService: ReportService,
		protected reviewService: ReviewService,
		protected userService: UserService,
		protected syncService: SyncService,
		protected listService: ListService,

		protected translateService: TranslateService
	) {}

	// Vars
	init_date = new Date(new Date().getFullYear(), 1, 1);
	calendarLocale = CalendarLocale;
	dateFormat = 'dd/MM/yy';
	end_date = new Date();
	delay = 600;

	@Input() loading: boolean = false;
	@Input() queryData: any = {};

	@Input() listOptionsReview: any = {};
	@Input() listOptions: any[] = [];

	// NEW PROPS
	
	@Input() checklist: ChecklistModel = new ChecklistModel();

	@Input() selectedListValueOptions = [];
	@Input() listValueOptions: {[k: string]: any[]} = {};

	@Input() headerItems: any[] | any = [];
	@Input() rawHeaderItemFilters: any[] = [];

	@Input() listResponses: any = [];
	@Input() listValues: any = [];
	@Input() lists: any = [];

	@Input() loadingInstitutes: boolean;
	@Input() loadingDepartments: boolean;

	// INTEGRATION FILTER PROPS
	genericIntegrationList: any = [];
	genericIntegration = {
		generic_integration_id: null,
		integration_id: null,
		reference_ids: '',
		text_data: '',
	};
	reviewFilters: any = {};
	review: any = {};
	menuIds = {};

	// NEW PROPS - Local
	headerFilterButtonShow = false;
	showHeaderItemFilter = false;
	headerFilterToggle = false;
	filterCollapsed = false;
	getSimilar = false;

	status = undefined;
	answerId: number = 0;
	instituteId: number = 0;
	departamentId: number = 0;

	lastEvent: any;

	// LOCAL GETTER (Selection)
	userOptions = [];
	users: any[] = []
	statusOptions = [];

	departmentOptions = [];
	departments: any[] = [];

	instituteOptions = [];
	institutes: any[] = [];

	instituteDepartmentOptions = [];
	instituteDepartments: any[] = [];

	checklistOptions = [];
	checklists: any[] = [];

	user: UserModel;

	// LOCAL ONLY
	withDescription: boolean;
	analisyStatus: number;

	// Shared Vars
	rawUsers: UserModel[] = [];

	// Translate Keys
	selectKey = '';
	approvedKey = '';
	reprovedKey = '';

	loadFilterOptions() {
		this.getUsers();
		this.getStatus();
		this.getChecklists();
		this.getCurrentUser();
		this.getListAndValues();
		this.getInstituteAndEstablishmentFilters();
	}

	getStatus() {
		this.translateService.get('translate_version').pipe(take(1)).subscribe(r => {
			this.selectKey = this.translate('select_o') || 'select_o';

			this.approvedKey = this.translate('approved') || 'approved';
			this.reprovedKey = this.translate('reproved') || 'reproved';

			this.statusOptions = [
				{ label: '', value: null },
				{ label: this.approvedKey, value: true },
				{ label: this.reprovedKey, value: false },
			];
		});
	}

	getUsers() {
		this.userService.getAll().subscribe((res) => {
				// Sharing user getter to the children
				this.rawUsers = res;

				res.forEach((item) => {
						this.userOptions.push({
								label: item.name,
								value: item,
						});
				});
		});
	}

	getGenericIntegrationFilters() {
		this.genericIntegrationList = [
			{ label: null, value: null },
		];

		this.genericIntService.getPaginated(0, 1e+8).subscribe((res) => {
			const data = res && res.rows;

			if (!data) {
				return console.info('Failed to get GenericIntegrationItems');
			}

			if (data && data.length) {

				const mappedData = data.map((gi: GenericIntegrationModel) => {
					return { label: gi.customer_name, value: gi.id };
				}).filter(m => m && m.value);

				if (mappedData && mappedData.length) {
					this.genericIntegrationList.push(...mappedData);
				} else {
					console.info('Nothing to show, B.');
				}

			} else {
				console.info('Nothing to show, A.');
			}

		});
	}

	getReviewIntegrationFilters() {
		this.reviewService.getFilters(this.review).subscribe((res) => {
				// formato a receber: label, value
				// this.reviewFilters = res as any;
				this.reviewFilters.models = [
					{ label: null, value: null },
					...res.models
				];
				this.reviewFilters.lines = [
					{ label: null, value: null },
					...res.lines
				];

				this.clearReviewFilters();
		});
	}

	clearReviewFilters() {
		this.review.line_id = null;
		this.review.model_id = null;
	}

	getChecklists() {
		this.checklistOptions = [{ label: '', value: null }];

		this.reportService.getChecklists({
			uniqueChecklists: true,
			withHeaderItems: true,
			withQuestions: false,
			withDefaults: false,
			withEmails: false,
			paranoid: false
		}).pipe(take(1))
		.subscribe((checklists: any) => {
			if (checklists && checklists.length)
			for (const check of checklists) {
				this.checklistOptions.push({
					label: check.name,
					value: check
				});
			}

			this.message.success('loaded_checklists');
			console.info('loaded_checklists');
		});
	}

	loadSelectedListValues() {
		this.selectedListValueOptions = [];

		const selectedLists = this.lists.filter((list) => this.listResponses.find((res) => res.id == list.id));

		if (this.listResponses.length) {
			const filteredLists =	selectedLists.filter((list) => list.values).map((list) => list.values);
			const allListValues = filteredLists.flatMap((values) => values);

			allListValues.forEach((item) => {
				const model = { label: item.description, value: item.id };
				this.selectedListValueOptions.push(model);
			})
		}
	}

	getInstituteAndEstablishmentFilters() {
		this.getInstituteDepartments();
		this.getDepartments();
		this.getInstitutes();
	}

	getInstituteDepartments() {
		this.syncService.getInstituteDepartments().subscribe(instDepartments => {
			this.instituteDepartments = instDepartments;
		}, (r) => this.errorHandler(r && r.error || r));
	}

	getDepartments() {
		this.loadingDepartments = true;

		this.syncService.getDepartments()
		.finally(() => this.loadingDepartments = false)
		.subscribe((results) => {
			const mapped = this.mapToList(results);
			this.departmentOptions = mapped;
			this.departments = mapped;
		}, (r) => this.errorHandler(r && r.error || r));
	}

	getInstitutes() {
		this.loadingInstitutes = true;

		this.syncService.getInstitutes()
		.finally(() => this.loadingInstitutes = false)
		.subscribe((results) => {
			const mapped = this.mapToList(results);
			this.instituteOptions = mapped;
			this.institutes = mapped;
		}, (r) => this.errorHandler(r && r.error || r));
	}

	onSelectInstitute() {
		this.departamentId = null;
		this.departmentOptions = [];

		if (this.instituteId && this.instituteDepartments && this.instituteDepartments.length) {
			const filtered = this.instituteDepartments.filter((instDep) =>
				instDep.institute_id == this.instituteId
			) || [];

			this.departmentOptions = filtered.length &&
			this.departments.filter(d => filtered.some(f => f.departament_id == d.value))
			|| [{ "label": this.translate('institute_without_departments'), "value": null }];
		}
	}

	// Future action
	onSelectDepartment = () => undefined

	canShowUsers = () => this.userOptions && this.userOptions.length > 0;

	getListValueOptions = (list_id) => this.listValueOptions[list_id] || [];

	emitFilter() {
		const user_ids = this.users.length > 0 ? this.users.map(user => user.id) : null;

		const query = {
			user: this.user,
			user_id: user_ids,

			status: this.status,
			answer_id: this.answerId,
			get_similar: this.getSimilar,
			institute_id: this.instituteId,
			departament_id: this.departamentId,
			origin_id: this.checklist.origin_id,
			// unconformities_only: this.unconformitiesOnly,

			init_date: moment(this.init_date).format(),
			end_date: moment(this.end_date).endOf('day').format(),

			header_items_filter: this.getGroupedHeaderItemsFilter(),

			with_description: this.withDescription,
			analisy_status: this.analisyStatus ? 1 : 0,

			// Review Filters
			line_id: this.review.line_id,
			model_id: this.review.model_id,

			// Generic Integration Filters
			...this.genericIntegration,

			// Shared vars
			raw_users: () => this.rawUsers,
		};

		this.hasChange.emit(query);
	}

	afterFilterToggle() {
		this.filterCollapsed = !this.filterCollapsed;
	}

	afterHeaderFilterToggle() {
		this.headerFilterToggle = !this.headerFilterToggle;
	}

	showHeaderFilterButton() {
		// this.showHeaderItemFilter = false;

		this.headerItems = [];
		this.headerItems = this.checklist.header_items;
		this.headerFilterButtonShow = this.checklist.name !== null;
	}

	updateSelectedListIds(data) {
		const [ ids, list ] = data;

		// null safetly validations
		const headerItemIndex = list.index;
		if (!this.headerItems[headerItemIndex]) this.headerItems[headerItemIndex] = {};
		if (!this.headerItems[headerItemIndex].response) this.headerItems[headerItemIndex].response = {};

		this.headerItems[headerItemIndex].response = ids;
	}

	getGroupedHeaderItemsFilter() {
		const groupedRawHeaderItems = [];
		const groupedListHeaderItems = [];

		if (this.headerItems && this.headerItems.length) {

			for (const headerItem of this.headerItems) {
				const { list_id, header_item_type, response } = headerItem;

				if (!response) continue;

				if (headerItem.list_id) {
					if (!groupedListHeaderItems[list_id]) {
						groupedListHeaderItems[list_id] = {};
						groupedListHeaderItems[list_id].response = [];

						groupedListHeaderItems[list_id].list_id = list_id;
						groupedListHeaderItems[list_id].header_item_type = header_item_type;
					}

					groupedListHeaderItems[list_id].response = response.map(v => v.id).filter(v => v);
				} else {
					if (!groupedRawHeaderItems[header_item_type]) {
						groupedRawHeaderItems[header_item_type] = {};
						groupedRawHeaderItems[header_item_type].response = [];
	
						groupedRawHeaderItems[header_item_type].list_id = null;
						groupedRawHeaderItems[header_item_type].header_item_type = header_item_type;
					}

					groupedRawHeaderItems[header_item_type].response.push(response);
				}

			}

		}

		return [
			...groupedListHeaderItems.filter(v => v), ...groupedRawHeaderItems.filter(v => v),
		];
	}

  getCurrentUser() {
		this.menuIds = {};

    this.userService.getCurrentUserData().subscribe((user) => {
			if (!user || !user.user_type) return console.error('Invalid User');

			const { menu_ids } = user.user_type || { menu_ids: '[]' };
			const menuIds = JSON.parse(menu_ids);

			if (menuIds && menuIds.length) {
				menuIds.forEach((n) => {
					this.menuIds[n] = 1;
				})
			}

			this.user = new UserModel(user);
    })
  }

	resetFilter() {
		this.setLastWeekDate();
		this.forceResetHeaders();
		this.clearReviewFilters();

		this.checklist = new ChecklistModel();

		this.headerFilterButtonShow = false;
		this.headerFilterToggle = false;

		this.clearDepartments();
		this.resetLegacyProps();

		this.listResponses = [];
		this.headerItems = [];
		this.users = [];

		this.departamentId = 0;
		this.instituteId = 0;
		this.answerId = 0;
		this.status = null;

		this.emitFilter();
	}

	updateFilterData(newEvent, queryData) {
		const date = newEvent ? {
			end: newEvent.rows ? newEvent.rows : newEvent.end || 10,
			init: newEvent.first ? newEvent.first : newEvent.init || 0,
		} : {};

		return { ...queryData || {}, ...newEvent || {}, ...date };
	}

	clearDepartments() {
		this.instituteId = null;
		this.departamentId = null;

		this.departmentOptions = this.mapToList(this.departments)
	}

	forceResetHeaders() {
		this.checklist.header_items.forEach((v, i) => {
			this.checklist.header_items[i].response = null;
		});
	}

	setLastWeekDate() {
		this.end_date = new Date(moment().endOf('day').format());
		this.init_date = new Date(moment().subtract(7, 'days').startOf('day').format());
	}

	resetLegacyProps() {
		// this.isDisableFilterUnconformityCheckbox = false;
		// this.filterUnconformityCheckbox = null;
		// this.filterAttachmentCheckbox = null;
		// this.unconformitiesOnly = false;
	}

	getSelectedListNames(i) {
		const res = this.headerItems[i].response;
		const validation = res && res.length ? res : [];
		return validation.map(r => r.description).join(', ');
	}

  onOpenListValueFilterModal(listId, index) {
    const list = this.lists && this.lists.length && this.lists.find(l => l.id == listId) || null;
    this.listValueFilterModal.onShow(listId, list, index, this.headerItems[index].response);
  }

	// Unused
	setHeaderItemResponse(index: number, { value }) {
		if (index > -1 && this.headerItems[index]) {
			this.headerItems[index].response = [value];
		}
	}

	getListAndValues() {
		this.selectedListValueOptions = [];
		this.listValueOptions = {};
		this.listOptions = [];
		this.lists = [];

		// get lists
		this.listService.getPaginated(0, 1e+8)
		.pipe(take(1)).subscribe(({ rows }) => {
			const lists = rows as ListModel[];
			this.lists = lists;

			for (const list of lists) {
				this.listOptions.push({
					label: list.name,
					value: list,
				});
			}
		});

		// get values
		if (!true) // not required, using list value filter modal
		this.listValueService.getAll({ init: 0, end: 1e+8 })
		.subscribe((data: { rows: ListValueModel[] }) => {
			if (data && data.rows && data.rows.length) {
				for (const value of data.rows) {
					if (!this.listValueOptions[value.list_id])
					this.listValueOptions[value.list_id] = [];
	
					this.listValueOptions[value.list_id].push({
						label: value.description, value,
					});
				}
			}

			this.message.success('loaded_list_and_values');
			console.info('loaded_list_and_values');
		});

		this.showHeaderItemFilter = true;
	}

	public translate = (key: string) => this.translateService &&
	this.translateService.instant(key) || key;

	protected mapToList(data: any[]) {
		const select = { name: '', id: null };
		const results = [ select, ...data ];

		return results.map((result) => {
			result.label = result.name;
			result.value = result.id;
			return result;
		});
	}

  protected errorHandler(error: any = {}) {
    const [errors, params] =  error.message && error.message.includes(':') ? error.message.split(':') : [error.message, '.'];
    return this.message.error(this.translate(errors) + params);
  }

	// translate = (key: string) => this.translateService.instant(key || "invalid");
	// tUpper = (key) => this.translate(key).toString().toUpperCase();
	// tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/checklist-response-filter-query/checklist-response-filter-query.component.ts